import React, { Component } from 'react';
import { Container, Row, Col, Button, Form, Alert, Spinner, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import AppSpinner from '../AppSpinner/AppSpinner';
import apiUrl from '../../utils/apiUrl';
import { connect } from 'react-redux';
import Switch from 'react-switch';
import { showEnterpriseDeletedNotification } from '../../redux/modules/notifications';
import './styles/styles.scss';

const select = state => {
  return {
    token: state.auth.token
  };
};

function mapDispatchToProps(dispatch) {
  return {
    showEnterpriseDeletedNotification: () => dispatch(showEnterpriseDeletedNotification())
  };
}

class ConnectedEnterpriseDetailComponent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      loadingDenyValidation: false,
      removeEnterprise: false,
      removeAvailable: false,
      removing: false,
      submitting: false,
      show: false,
      isLoading: true,
      validation: false,
      bankAccountValidation: false,
      enterpriseNotFound: false,
      data: {
        name: { value: '' },
        clientServiceNumber: { value: '' },
        email: { value: '' },
        logo: { value: '' },
        website: { label: 'Página Web', value: '', changed: false },
        address: { label: 'Dirección', value: '', changed: false },
        country: { label: 'País', value: '', changed: false },
        description: { label: 'Descripción', value: '', changed: false, type: 'textarea', cols: 12 },
        instagram: { label: 'Instagram', value: '', changed: false, cols: 4 },
        facebook: { label: 'Facebook', value: '', changed: false, cols: 4 },
        twitter: { label: 'Twitter', value: '', changed: false, cols: 4 },
        contactName: { label: 'Nombre del contacto', value: '', changed: false, cols: 3 },
        contactEmail: { label: 'Email de contacto', value: '', changed: false, cols: 3 },
        contactPhone: { label: 'Teléfono de contacto', value: '', changed: false, cols: 3 },
        contactAddress: { label: 'Dirección de contacto', value: '', changed: false, cols: 3 },
        locations: { value: '' },
        ods: { value: '' },
        typeOfComerce: { value: '' },
        category: { value: '' },
        subcategory: { value: '' },
        bankAccountNumber: { label: 'Número de cuenta bancaria', value: '', changed: false },
        bankAccountType: { label: 'Tipo de cuenta bancaria', value: '', changed: false },
        bankName: { label: 'Nombre del banco', value: '', changed: false },
        bankAccountCertificate: { cols: 6, fileType: 'application/pdf', file: '', label: 'Certificado de cuenta bancaria (PDF)', value: '', changed: false },
        representativeIdentification: { cols: 6, fileType: 'application/pdf', file: '', label: 'Copia de la cédula del representante legal (PDF)', value: '', changed: false }
      }
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.renderInputFields = this.renderInputFields.bind(this);
    this.renderFileInputs = this.renderFileInputs.bind(this);
    this.handleSwitchChange = this.handleSwitchChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.removeEnterprise = this.removeEnterprise.bind(this);
    this.removeInputChange = this.removeInputChange.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.denyValidation = this.denyValidation.bind(this);
  }

  async denyValidation() {
    const { id, token, history } = this.props;
    this.setState({ loadingDenyValidation: true });

    const promise = await fetch(`${apiUrl}/admin/enterprises_foundations/deny_validation?token=${token}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        type: 'ENTERPRISE',
        id
      })
    });

    const removeResp = await promise.json();

    if (removeResp.success) history.push('/comercios');

  }

  removeEnterprise() {
    this.setState({ removeEnterprise: true });
  }

  removeInputChange(event) {
    this.setState({ removeAvailable: event.target.value === 'ELIMINAR' });
  }

  async handleRemove() {
    const { id, token, history } = this.props;
    this.setState({ removing: true });

    const removeResponse = await fetch(`${apiUrl}/admin/enterprises/remove_enterprise?token=${token}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        entRemoveId: id
      })
    });

    const removeResp = await removeResponse.json();

    if (removeResp.success) {
      await this.props.showEnterpriseDeletedNotification();
      history.push('/comercios');
    }
  }

  handleSwitchChange(checked, name) {
    this.setState({ [name]: checked });
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleInputChange(event) {
    const { data } = this.state;

    const updatedData = { 
      ...data, [event.target.name]: { 
        ...data[event.target.name],
        value: event.target.value,
        changed: true
      }
    };

    this.setState({ data: updatedData });
  }

  async componentDidMount() {

    const { id, token } = this.props;

    const enterpriseResp = await fetch(`${apiUrl}/admin/enterprise/${id}?token=${token}`);
    const enterpriseData = await enterpriseResp.json();

    if (enterpriseData.success) {

      const { data } = this.state;
      const { enterprise } = enterpriseData;

      const newData = {};

      Object.keys(data).forEach(key => {
        const original = data[key];
        const newObj = {...original, value: enterprise[key]};

        newData[key] = newObj;
      });

      this.setState({
        data: newData,
        validation: enterprise.validation === '2',
        bankAccountValidation: enterprise.bankAccountValidation,
        bankInfoToValidate: enterprise.bankInfoToValidate
      });

    } else {
      this.setState({ enterpriseNotFound: true });
    }

    this.setState({ isLoading: false });
  }

  renderInputFields(fields) {

    const { data } = this.state;

    const inputs = Object.keys(fields).map(key => {

      const {
        label,
        value,
        type,
        cols
      } = data[key];

      return (
        <Form.Group key={key} as={Col} md={cols ? cols : 4}>
          <Form.Label><strong>{label}:</strong></Form.Label>
          <Form.Control
            type="text"
            onChange={this.handleInputChange}
            value={value}
            name={key}
            placeholder={label}
            as={type === 'textarea' ? 'textarea' : 'input'}
            rows={type === 'textarea' ? '3' : '1'}
          />
          <Form.Control.Feedback type="invalid">
            Valor inválido.
          </Form.Control.Feedback>
        </Form.Group>
      );
    });

    return inputs;
  }

  renderFileInputs(files) {

    const { data } = this.state;
    
    const inputs = Object.keys(files).map(key => {

      const {
        label,
        value,
        fileType,
        file,
        cols,
        changed
      } = data[key];

      let fileNameArr, fileName, displayedName;

      if (value) {
        fileNameArr = value.split('com/');
        fileName = fileNameArr.length > 1 ? fileNameArr[1] : fileNameArr[0];
        displayedName = fileName.length > 25 ? `${fileName.substring(0, 25)}...` : fileName;
      }

      return (
        <Form.Group key={key} as={Col} md={cols ? cols : 4}>
          <Form.Label><strong>{label}:</strong></Form.Label>
          <Form.Control
            type="file"
            ref={fileInput => this[key] = fileInput}
            name={key}
            files={file}
            onChange={this.handleFileChange}
            accept={fileType}
            hidden
          />
          <div className="form-custom-file-input">
            <Button onClick={() => this.triggerInputFile(key)}>
              Selecciona un archivo
            </Button>
            <span style={{marginLeft: '5px'}}>
              {
                value ? 
                (changed ? displayedName :
                <a href={value} target="_blank" rel="noopener noreferrer">{displayedName}</a>) :
                'No hay archivos seleccionados'
              }
            </span>
          </div>
        </Form.Group>
      );

    });

    return inputs;
    
  }

  async handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();

    this.setState({ submitting: true });

    const {
      data,
      validation,
      bankAccountValidation,
      bankInfoToValidate
    } = this.state;
    const { token, id } = this.props;
    const updatedData = {};

    Object.keys(data).forEach(async key => {

      const obj = {...data[key]};
      if (obj.changed) updatedData[key] = obj.value;
      
    });

    updatedData.validation = validation ? '2' : '1';
    updatedData.bankAccountValidation = bankAccountValidation;
    
    if (bankInfoToValidate && bankAccountValidation) updatedData.bankInfoToValidate = false;

    const updateEnterprise = await fetch(`${apiUrl}/admin/enterprises/update?token=${token}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id,
        update: updatedData
      })
    });

    const updateEnterpriseJson = await updateEnterprise.json();

    if(updateEnterpriseJson.success) this.setState({ show: true });

    this.setState({ submitting: false });

  }

  render() {

    const {
      isLoading,
      data,
      validation,
      bankAccountValidation,
      submitting,
      show,
      enterpriseNotFound,
      removeEnterprise,
      removing,
      removeAvailable,
      loadingDenyValidation
    } = this.state;

    if (isLoading) return (<AppSpinner />);
    if (enterpriseNotFound) return (<h1 className="not-found-error">El comercio especificado no existe.</h1>);

    const {
      name,
      clientServiceNumber,
      email,
      logo,
      contactName,
      contactEmail,
      contactPhone,
      contactAddress,
      facebook,
      instagram,
      twitter,
      locations,
      ods,
      typeOfComerce,
      category,
      subcategory,
      bankAccountNumber,
      bankAccountType,
      bankName,
      bankAccountCertificate,
      representativeIdentification,
      ...fields
    } = data;

    const socialMedia = { twitter, facebook, instagram };
    const contactInfo = { contactName, contactPhone, contactEmail, contactAddress };
    const bankInfo = { bankAccountNumber, bankAccountType, bankName };
    const bankAccountFiles = { bankAccountCertificate, representativeIdentification };

    return (
      <div className="detail-info-component enterprise-detail-component">
        <Container>
          <Row>
            <Col xs={12}>
              <div className="user-detail-options">
                <Link to="/comercios">
                  <Button variant="secondary">
                    Atrás
                  </Button>
                </Link>
                <Button variant="danger" onClick={this.removeEnterprise}>
                  Eliminar comercio
                </Button>
              </div>
            </Col>
            <Col xs={12}>
              <div style={{ display: 'flex' }}>
                <img src={logo.value} alt="" />
                <div className="header-info">
                  <h2>{name.value}</h2>
                  <h5><strong>Correo: </strong> {email.value}</h5>
                  <h5><strong>Teléfono: </strong>{clientServiceNumber.value}</h5>
                </div>
              </div>
              <hr />
            </Col>
            <Col xs={12}>

              <Form onSubmit={this.handleSubmit}>
                <Form.Row>
                  {this.renderInputFields(fields)}
                  <Form.Group as={Col} md={4}>
                    <Form.Label><strong>Sedes:</strong></Form.Label>
                    { 
                      locations &&
                      <Form.Control
                        type="text"
                        defaultValue={locations.value ? locations.value.map(ods => 
                          ods.label
                        ).join(', ') : ''}
                        disabled
                      />
                    }
                    
                  </Form.Group>

                  <Form.Group as={Col} md={4}>
                    <Form.Label><strong>Tipo de comercio:</strong></Form.Label>
                    {
                      typeOfComerce &&
                      <Form.Control
                        type="text"
                        defaultValue={typeOfComerce.value ? typeOfComerce.value.label : ''}
                        disabled
                      />
                    }
                  </Form.Group>

                </Form.Row>

                <hr />

                <h4>Redes sociales:</h4>

                <Form.Row>
                  {this.renderInputFields(socialMedia)}
                </Form.Row>

                <hr />

                <h4>Información de contacto:</h4>

                <Form.Row>
                  {this.renderInputFields(contactInfo)}
                </Form.Row>

                <hr />

                <h4>Categorización:</h4>

                <Form.Row>

                  <Form.Group as={Col} md={4}>
                    <Form.Label><strong>Categoría:</strong></Form.Label>
                    {
                      category &&
                      <Form.Control
                        type="text"
                        defaultValue={category.value ? category.value.label : ''}
                        disabled
                      />
                    }
                  </Form.Group>

                  <Form.Group as={Col} md={4}>
                    <Form.Label><strong>Subcategoría:</strong></Form.Label>
                    {
                      subcategory &&
                      <Form.Control
                        type="text"
                        defaultValue={subcategory.value ? subcategory.value.label : ''}
                        disabled
                      />
                    }
                  </Form.Group>

                  <Form.Group as={Col} md={4}>
                    <Form.Label><strong>ODS:</strong></Form.Label>
                    {
                      ods &&
                      <Form.Control
                        type="text"
                        defaultValue={ods.value ? ods.value.map(ods => 
                          ods.label
                        ).join(', ') : ''}
                        disabled
                      />
                    }
                  </Form.Group>
                </Form.Row>


                <h4>Cuenta bancaria:</h4>

                <Form.Row>
                  {this.renderInputFields(bankInfo)}
                </Form.Row>

                <Form.Row>
                  {this.renderFileInputs(bankAccountFiles)}
                </Form.Row>
                <hr />

                {
                  !validation &&
                  <Button variant="danger" style={{ marginBottom: '20px' }} onClick={this.denyValidation}>
                    {
                      loadingDenyValidation ?
                      <Spinner animation="border" variant="warning" size="sm" /> :
                      'Rechazar comercio'
                    }
                  </Button>
                }

                <Alert variant="info">
                  <h4>Validación:</h4>

                  <Row className="justify-content-center">
                    <Col className="switch-col" lg={6}>
                      <div className="switch-input">
                        <span>Validar comercio</span>
                        <Switch
                          onChange={checked => this.handleSwitchChange(checked, 'validation')}
                          checked={validation}
                        />
                      </div>
                    </Col>
                    <Col className="switch-col" lg={6}>
                      <div className="switch-input">
                        <span>Validar información bancaria</span>
                        <Switch
                          onChange={checked => this.handleSwitchChange(checked, 'bankAccountValidation')}
                          checked={bankAccountValidation}
                        />
                      </div>
                    </Col>
                  </Row>
                </Alert>

                <div className="form-buttons">

                  <Link to="/comercios">
                    <Button variant="secondary">
                      Atrás
                    </Button>
                  </Link>

                  <Button type="submit" className="nibi-btn">
                    {
                      submitting ? <Spinner animation="border" variant="warning" size="sm" /> : 'Guardar cambios'
                    }
                  </Button>
                </div>

              </Form>

            </Col>
          </Row>
        </Container>

        <Modal show={show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Cambios guardados</Modal.Title>
          </Modal.Header>
          <Modal.Body>Se han guardado los cambios</Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={this.handleClose}>
              Aceptar
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={removeEnterprise} onHide={() => this.setState({ removeEnterprise: false, removing: false })}>
          <Modal.Header closeButton>
            <Modal.Title>Eliminar comercio</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {
              validation ?
              <Alert variant="warning">
                No puedes eliminar un comercio que ya fue validado.
              </Alert> :
              removing ? <AppSpinner /> :
              <>
                <Alert variant="danger">
                  Esta acción no se puede deshacer.
                  El comercio será eliminado permanentemente.
                </Alert> 
                
                <Form.Row>
                  <Form.Group as={Col} xs={12}>
                    <p>
                      Por favor excriba ELIMINAR para confirmar.
                    </p>
                    <Form.Control
                      type="text"
                      onChange={this.removeInputChange}
                    />
                  </Form.Group>
                  <Col className="modal-btn-col" xs={12}>
                    <Button variant="secondary" onClick={() => this.setState({ removeEnterprise: false, removing: false })}>
                      Cancelar
                    </Button>
                    <Button variant="danger" disabled={!removeAvailable} onClick={this.handleRemove}>
                      Eliminar
                    </Button>
                  </Col>
                </Form.Row>
              </>
            }
          </Modal.Body>
        </Modal>

      </div>
    );
  }
}

const EnterpriseDetailComponent = connect(select, mapDispatchToProps)(ConnectedEnterpriseDetailComponent);

export default EnterpriseDetailComponent;
